import { render, staticRenderFns } from "./ListTrashUser.vue?vue&type=template&id=ef9bdbfa&scoped=true"
import script from "./ListTrashUser.vue?vue&type=script&lang=js"
export * from "./ListTrashUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9bdbfa",
  null
  
)

export default component.exports